module.exports = __webpack_public_path__ + "static/media/snappy_mail_trial.accfbf48.svg";